<ng-container *ngIf="node">
    <div class="notification__message-banner" [innerHTML]="node.subject"></div>
    <svg-image *ngIf="node.canBeDeleted" name="plus" class="notification__close" (click)="deleteNotification(node.id)"></svg-image>
</ng-container>
